export default __webpack_public_path__ + "static/media/Shell_logo.6952dd14.png";